import { Theme } from './themes'

const textLight = {
  primary: 'rgba(52, 49, 76, 1)',
  secondary: 'rgba(52, 49, 76, 0.54)',
  disabled: 'rgba(52, 49, 76, 0.38)',
  hint: 'rgba(52, 49, 76, 0.38)',
}

const errorColor = {
  main: '#FF3D57',
}

const themeColors = {
  topbar: {
    palette: {
      type: 'light',
      primary: {
        main: '#ffffff',
        contrastText: textLight.primary,
      },
      secondary: {
        main: '#1976d2',
        contrastText: '#ffffff',
      },
      text: textLight,
    },
  },
  sidebar: {
    palette: {
      type: 'dark',
      primary: {
        main: '#222A45',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#ff9e43',
        contrastText: textLight.primary,
      },
      error: errorColor,
      background: {
        paper: '#222A45',
        default: '#1a2038',
      },
    },
  },
}

const buildThemeForPrimaryColor = (
  primaryColorHex = '#1976d2',
  primaryColorDark = 'rgba(52, 49, 76, 1)',
  primaryColorDarkContrast = '#fff'
) => ({
  palette: {
    type: 'light',
    primary: {
      main: primaryColorHex,
      contrastText: '#ffffff',
    },
    primaryDark: {
      main: primaryColorDark,
      contrastText: primaryColorDarkContrast,
    },
    secondary: {
      main: '#AAA',
      contrastText: textLight.primary,
    },
    error: errorColor,
    text: textLight,
  },
})

themeColors[Theme.HALL] = buildThemeForPrimaryColor(
  '#0033FF',
  '#0D1B4B',
  '#ffffff'
)
themeColors[Theme.AMSM] = buildThemeForPrimaryColor()
themeColors[Theme.AFA] = buildThemeForPrimaryColor('#175a93')
themeColors[Theme.CIC] = buildThemeForPrimaryColor()
themeColors[Theme.CLAB] = buildThemeForPrimaryColor('#6791E4', '#111111')
themeColors[Theme.ACTION] = buildThemeForPrimaryColor()
themeColors[Theme.IGORSANDI] = buildThemeForPrimaryColor('#3a45cc')
themeColors[Theme.GUILHERMELAZARETTI] = buildThemeForPrimaryColor(
  '#151616',
  '#151616'
)
themeColors[Theme.LARISSACIOATO] = buildThemeForPrimaryColor(
  '#d6a800',
  '#111111'
)
themeColors[Theme.BIOACADEMIA] = buildThemeForPrimaryColor('#d0951e', '#0b4824')
themeColors[Theme.DCFIT] = buildThemeForPrimaryColor('#226099')
themeColors[Theme.EXOS] = buildThemeForPrimaryColor('#005fac', '#030338')

// TODO: Set primary color and login background
themeColors[Theme.GIBA] = buildThemeForPrimaryColor('#007aff', '#005fac')

themeColors[Theme.OFRAGOZO] = buildThemeForPrimaryColor('#1b2a5e', '#0d1631')

themeColors[Theme.RENA] = buildThemeForPrimaryColor('#d23e81', '#8f2356')

themeColors[Theme.THESTUDIO] = buildThemeForPrimaryColor('#4A2018', '#2E130D')
themeColors[Theme.PEM] = buildThemeForPrimaryColor('#0053AA', '#023A69')

export { themeColors }
